import { render } from "./KLabropoulou.vue?vue&type=template&id=d304bc28"
import script from "./KLabropoulou.vue?vue&type=script&lang=js"
export * from "./KLabropoulou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__